module.exports = __webpack_public_path__ + "img/32d5e5f.png";